// Angular
import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationEnd } from '@angular/router';
// RxJS
import { Subscription } from 'rxjs';
// Layout
import { SubheaderService } from '../../../../../core/_base/layout';
import { Breadcrumb } from '../../../../../core/_base/layout/services/subheader.service';
import { UntypedFormControl } from '@angular/forms';
import { UnitService } from '../../../../../core/configuration/_services/unit.service';
import { WidgetDashboardService } from '../../../../../core/widget-dashboard/widget-dashboard.service';
import { DateService } from '../../../../../core/generic/_services/date.service';
import { FacilityService } from '../../../../../core/configuration/_services/facility.service';
import { ConfigurationUtilService } from "../../../../../core/configuration/_services/configuration-util.service";
import { UserService } from '../../../../../core/auth/_services/user.service';
import { fleetdata, plantData } from './FacilityDataJson';

import { environment } from '../../../../../../environments/environment';
import _ from 'lodash';
import dayjs from 'dayjs';
import { ResponsiveViewService } from '../../../../../core/configuration/_services/responsive-view.service';
import { SelectOption } from '../../../../components/primitives/primitives.types';
@Component({
	selector: 'kt-subheader2',
	templateUrl: './subheader2.component.html',
	styleUrls: ['./subheader2.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class Subheader2Component implements OnInit, OnDestroy, AfterViewInit {
	// Public properties
	activatedRouteParams = this.activatedRoute.snapshot.queryParams
	isGISView: boolean = false;
	isDashboardPage = false;
	enableFullPage = false
	isCommercialized = environment.runtime.commercialized
	today: number = Date.now();
	todayDate: any = new Date()
	title: string = '';
	desc: string = '';
	isDGRDatePicked: boolean = false;
	dgrDate: string = '';
	facilitySelector: boolean;
	showPageSwitcher: boolean = false;
	hideTimeWindow: boolean = false;
	hideSubHeader: boolean = false;
	breadcrumbs: Breadcrumb[] = [];
	dashboard = "";
	currentTimeSelected = {
		id: 4,
		name: 'Last 30 Days'
	}
	timeWindow = [{
		id: 1,
		name: 'Today'
	},
	// {
	// 	id: 2,
	// 	name: 'Yesterday'
	// },
	{
		id: 3,
		name: 'Last 7 Days'
	},
	{
		id: 4,
		name: 'Last 30 Days'
	},
	{
		id: 5,
		name: 'Last 6 months'
	},
	{
		id: 6,
		name: 'Last 12 months'
	},
	{
		id: 7,
		name: 'All'
	}]

	facilityList: any = [];

	selectedFacilityList = new UntypedFormControl();
	dgpData = new UntypedFormControl();
	unitValue = new UntypedFormControl();
	userUnits = [];
	isAdmin = false;

	// Private properties
	private subscriptions: Subscription[] = [];
	userFacility: any;
	currentUnits: any = [];
	currentFacilityId: any;
	hasAccessToDGR: any = false;
	mobileView: boolean = false;
	facilityOptions: SelectOption[] = [];
	unitOptions: SelectOption[] = [];
	private facilityValueChangesSubscribed = false;
	private unitListSubscribed = false;

	private syncFacilityOptions(): void {
		this.facilityOptions = (this.facilityList || []).map(f => ({
			label: f.name,
			value: f._id,
			tooltip: f.name
		}));
	}

	private syncUnitOptions(): void {
		this.unitOptions = (this.currentUnits || []).map(u => ({
			label: u.name,
			value: u._id,
			tooltip: u.name
		}));
	}

	/**
	 * Component constructor
	 *
	 * @param subheaderService: SubheaderService
	 */
	constructor(
		public subheaderService: SubheaderService,
		public DateService: DateService,
		private readonly userService: UserService,
		private readonly widgetDashboardService: WidgetDashboardService,
		private readonly facilityService: FacilityService,
		public _changeDetectorRef: ChangeDetectorRef,
		private readonly unitService: UnitService,
		private readonly cUtilService: ConfigurationUtilService,
		private readonly activatedRoute: ActivatedRoute,
		private readonly responsiveViewService: ResponsiveViewService,
		private readonly _router: Router) {
		// this._router.events.subscribe((event: Event) => {
		// 	if (event instanceof NavigationEnd) {

		// 		console.log(this._route.snapshot.queryParams['unit'], 'sds');
		// 	}
		// });
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		if (!this.isCommercialized) { //this is making date range to default All in demo servers
			this.onRangeSelection({
				id: 7,
				name: 'All'
			})
		}
		this.responsiveViewService.isMobileView$.subscribe(value => {
			this.mobileView = value;
		});
		this.userUnits = this.userService.getLoggedInUser()?.unit || [];
		this.isAdmin = this.userService.getLoggedInUser()?.admin || false;
		this.userFacility = this.userService.getLoggedInUser()?.facility || [];
		this.dashboard = environment.runtime.dashboard;

		let userFacDetails = this.userService.getLoggedInUser()?.facilityDetails || [];
		this.hasAccessToDGR = userFacDetails.filter(f => f.type === 7 || f.type === 8).length !== 0
		this.subscriptions.push(
			this.DateService.dateRangeSelectionChanged.subscribe(t => {
				let range: any = t;
				if (!range?.from) {
					this.currentTimeSelected = {
						id: 7,
						name: 'All'
					}
				}
			})
		)
		if (!environment.runtime.commercialized) {
			this.subscriptions.push(
				this.DateService.setEmptyUnit.subscribe(() => {
					this.unitValue.setValue('');
				})
			)
		}

		if (this.currentTimeSelected.id == 4) {
			//default selection - last 30 days
			const from = dayjs().subtract(30, 'day').startOf('day').toDate();
			const to = dayjs().toDate();
			this.DateService.dateRange = { from: from, to: to };
		}

		this._addSubscriptionForSubheader2FacilityListChanged();

		if (this.dashboard == 'renewables-dashboard' || (this.dashboard == 'fleet-dashboard' && this.activatedRoute.snapshot.queryParamMap.get('d') != '2') || (environment.runtime.dashboard == 'pdo-dashboard' && this.activatedRoute.snapshot.queryParamMap.get('d') == '2')) {
			this.isGISView = true;
			this._addSubscriptionForFacilityChanged(); // this is for hiding GIS View button
			this._addSubscriptionForSetValueFacility(); // this is for setting facility value in dropdown
		}
	}

	_addSubscriptionForSubheader2FacilityListChanged() {
		this.subscriptions.push(
			this.facilityService.subheader2FacilityListChanged.subscribe(f => {
				if (environment.runtime.commercialized) {
					// assigning only those facility that user has access to
					if (this.isAdmin) this.facilityList = f;
					else if (!this.isAdmin && this.userFacility.length)
						this.facilityList = f.filter(facility => this.userFacility?.includes(facility._id));
					else
						//TODO: Redirect to a valid page or show a message to connect with Administrator
						this._router.navigate(['/web/model-wizard'], {});

					this.syncFacilityOptions();

					this.currentFacilityId = this.facilityList[0]?._id;

					this._addSubscriptionForUnitListChanged();
					const unitProjection = "facility,_id,name";
					this.unitService.getUnit(unitProjection);

					this.selectedFacilityList.setValue(this.facilityList?.[0]._id);
					this.DateService.facilityData = this.facilityList?.[0];

					this._addSubscriptionForChangeofSelectedFacility();
				} else {
					this.fillFacilityListForDemo();
					let facility: any = {};
					if (f.length == 0)
						//navigate to model wizard since no facilites exist on this server.
						this._router.navigate(['/web/model-wizard'], {});
					else if (this.isAdmin)
						facility = f[0];
					else if (!this.isAdmin && this.userFacility.length)
						facility = f.find(facility => this.userFacility[0] == facility._id);
					else
						facility = f[0];

					if (facility && Object.keys(facility).length > 0) {
						let f = this.facilityList.find(ff => {
							if ([1, 7, 8].includes(facility.type)) {
								return ff.type == facility.type;
							} else {
								return ff.type == 2;
							}
						});
						this.selectedFacilityList.setValue(f._id);
						this.DateService.facilityData = f;
					} else {
						this.selectedFacilityList.setValue(3)
						this.DateService.facilityData = this.facilityList[2];
					}

					if (!this.isAdmin)
						this.facilityList = this.facilityList.filter(f => f.type == facility.type);

					this.syncFacilityOptions();

					if (this.dashboard != 'renewables-dashboard')
						this.DateService.facilityChanged.emit(this.DateService.facilityData)
				}
			})
		)
	}

	_addSubscriptionForUnitListChanged() {
		if (this.unitListSubscribed) return;
		this.unitListSubscribed = true;

		this.subscriptions.push(
			this.unitService.unitListChanged.subscribe(u => {
				if (this.facilityList.length > 0) {
					this.facilityList.forEach(ele => {
						let filterUnits = this.cUtilService?.filterUnitByFacilityId(u, ele._id);
						if (!this.isAdmin) {
							filterUnits = this.cUtilService.filterUnitByFacilityId(u, ele._id).filter(ele => this.userUnits.includes(ele._id));
						}
						ele['units'] = filterUnits.sort((a, b) => a?.name?.split(' ')[1] - b?.name?.split(' ')[1]);
						ele['activePlant'] = '';
					})
					this.facilityList[0].activePlant = this.facilityList[0]?.units[0]?._id
				}
				this.syncFacilityOptions();
				if (this.dashboard != 'renewables-dashboard') {
					this.DateService.facilityChanged.emit(this.facilityList[0]);
				}
				this.selectedFacilityList.setValue(this.facilityList[0]._id);
				this.DateService.facilityData = this.facilityList[0];
				if (!environment.runtime.commercialized) {
					this.unitValue.setValue(this.facilityList[0]?.units[0]?.name);
				}
			})
		)
	}

	_addSubscriptionForChangeofSelectedFacility() {
		if (this.facilityValueChangesSubscribed) return;
		this.facilityValueChangesSubscribed = true;

		this.subscriptions.push(
			this.selectedFacilityList.valueChanges.subscribe(f => {
				let facilities = Object.values(_.merge({}, this.facilityList))
				let currentFacility;
				for (let facility of facilities) {
					if (facility['_id'] == f)
						currentFacility = facility
				}
				this.currentUnits = currentFacility?.units
				this.syncUnitOptions();
				const activePlant = currentFacility?.activePlant;
				const defaultUnit = this.currentUnits?.[0]?._id;
				const unitId = activePlant && this.currentUnits?.some(u => u._id === activePlant)
					? activePlant
					: defaultUnit;
				this.unitValue.setValue(unitId);
			})
		)
	}

	_addSubscriptionForSetValueFacility() {
		this.DateService.facilityChanged.subscribe((res) => {
			this.selectedFacilityList.setValue(res._id);
			this.currentFacilityId = res._id;
		})
	}

	_addSubscriptionForFacilityChanged() {
		this.DateService.showGISView.subscribe((res: boolean) => {
			this.isGISView = res;
			this._changeDetectorRef.detectChanges();
		})
	}

	fillFacilityListForDemo() {
		this.facilityList = [
			// {
			// 	name: 'Solar Fleet',
			// 	_id: 1,
			// 	data: fleetdata,
			// 	units: [{ _id: 'Walton', name: 'Walton' }, { _id: 'Bear Creek', name: 'Bear Creek' }, { _id: 'Fern Solar', name: 'Fern Solar' }],
			// 	activePlant: '',
			//	type: 8
			// },
			// {
			// 	name: 'Wind Fleet',
			// 	_id: 2,
			// 	data: {},
			// 	units: [{ _id: 'Fowler', name: 'Fowler' }, { _id: 'Desert Creek', name: 'Desert Creek' }, { _id: 'Cedar Creek', name: 'Cedar Creek' }],
			// 	activePlant: ''
			//	type: 7
			// },
			{
				name: 'Wind',
				_id: 3,
				data: {},
				activePlant: '',
				type: 7
			},
			{
				name: 'Solar',
				_id: 4,
				data: {},
				activePlant: '',
				type: 8
			},
			{
				name: 'Fossil Fleet',
				_id: 5,
				data: fleetdata,
				units: [{ _id: 'Fayette', name: 'Fayette' }, { _id: 'Tulsa', name: 'Tulsa' }, { _id: 'Vogle', name: 'Vogle' }, { _id: 'Ferguson', name: 'Ferguson' }],
				activePlant: '',
				type: 2
			},
			{
				name: 'Energy & Emissions',
				_id: 6,
				data: {},
				activePlant: '',
				type: 1
			},
			// {
			// 	name: 'Emission',
			// 	_id: 7,
			// 	data: {},
			// 	activePlant: '',
			// 	type: 1
			// },
		]
		this.syncFacilityOptions();
	}

	/**
	 * After view init
	 */
	ngAfterViewInit(): void {
		this.subscriptions.push(this.subheaderService.title$.subscribe(bt => {
			// breadcrumbs title sometimes can be undefined
			if (bt) {
				Promise.resolve(null).then(() => {
					this.title = bt.title;
					this.desc = bt.desc;
					this.facilitySelector = bt.facilitySelector;
					this.hideTimeWindow = bt.hideTimeWindow;
					this.showPageSwitcher = bt.showPageSwitcher;
					this.isDashboardPage = bt.isDashboardPage;
					this.enableFullPage = bt.enableFullPage;
					this.hideSubHeader = bt.hideSubHeader;
					// hideing subHeader of GISView when the Tab Switched.
					if ((this.dashboard == 'renewables-dashboard' || (this.dashboard == 'fleet-dashboard' && this.activatedRoute.snapshot.queryParamMap.get('d') != '2')) || this.enableFullPage || (environment.runtime.dashboard == 'pdo-dashboard' && this.activatedRoute.snapshot.queryParamMap.get('d') == '2' )) {
						this.isGISView = true;
					} else
						this.isGISView = false;
					this._changeDetectorRef.detectChanges();
				});
			}
		}));

		this.subscriptions.push(this.subheaderService.breadcrumbs$.subscribe(bc => {
			Promise.resolve(null).then(() => {
				this.breadcrumbs = bc;
			});
		}));

		this.subscriptions.push(
			this.DateService.plantChanged.subscribe(({ ele, _id, name }) => {
				this.onPlantChange({ value: ele }, _id);
				if (!environment.runtime.commercialized) {
					this.unitValue.setValue(name);
				}
				// this._router.navigate([], {
				// 	relativeTo: this._route,
				// 	queryParams: { unit: ele },
				// 	// queryParamsHandling: 'merge',
				//   });
			})
		)
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.subscriptions.forEach(sb => sb.unsubscribe());
	}

	onUnitChange(e) {
		this.DateService.unitChanged.emit(e.value);
	}

	onClick(_id) {
		if (_id === this.selectedFacilityList.value) {
			let dataIndex = this.facilityList.findIndex(f => f._id === _id);
			this.facilityList[dataIndex].activePlant = '';
			if (!environment.runtime.commercialized) {
				this.unitValue.setValue('') // set unit value
			}
			this.facilityList[dataIndex].data = [fleetdata[_id - 1]];
			this.DateService.facilityData = this.facilityList[dataIndex]
			this.DateService.facilityChanged.emit(this.facilityList.find(f => f._id === _id))
			// this._router.navigate([], {
			// 	relativeTo: this._route,
			// 	queryParams: {},
			// 	// queryParamsHandling: 'merge',
			//   });
		}
	}

	dgpDatePicked(e) {
		this.isDGRDatePicked = false
		this.dgrDate = new Date(e.value).toISOString()
		this._changeDetectorRef.detectChanges();
	}

	downloadDGR(e) {
		if (!this.dgrDate) {
			let yesterDay = new Date()
			yesterDay.setDate(yesterDay.getDate() - 1)
			this.dgrDate = yesterDay.toDateString()
		}
		this.widgetDashboardService.getDGRReport(this.currentFacilityId).subscribe((res: any) => {
			const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const url = window.URL.createObjectURL(blob);
			var a = document.createElement("a");
			a.href = url
			let fdate = new Date(this.dgrDate).toDateString()
			a.download = `DGR Report - ${fdate}` + '.xlsx';
			a.click();
			window.URL.revokeObjectURL(url);
			a.remove()
		})
	}

	onFacilityChange(e) {
		for (const facility of this.facilityList) {
			if (facility.activePlant) {
				facility.activePlant = '';
				break;
			}
		}
		let getFacilityIndex = this.facilityList.findIndex(f => f._id === e.value);
		this.facilityList[getFacilityIndex].data = [fleetdata[e.value - 1]];
		this.currentFacilityId = e.value
		this.facilityList[getFacilityIndex].activePlant = this.facilityList[getFacilityIndex]?.units[0]?._id
		this.DateService.facilityData = this.facilityList[getFacilityIndex]
		this.DateService.facilityChanged.emit(this.facilityList[getFacilityIndex])
	}

	onPlantChange(_e, _id) {
		let getFacilityIndex = this.facilityList.findIndex(f => f._id === _id);
		this.facilityList[getFacilityIndex].activePlant = _e.value;
		if (!environment.runtime.commercialized) {
			this.setUnitName(this.facilityList[getFacilityIndex]);
		}
		this.facilityList[getFacilityIndex].data = [plantData[_id - 1]];
		if (_id !== this.selectedFacilityList.value) {
			let dataIndex = this.facilityList.findIndex(f => f._id === this.selectedFacilityList.value);
			this.facilityList[dataIndex].activePlant = '';
			if (!environment.runtime.commercialized) {
				this.unitValue.setValue('') // set unit value
			}
			this.selectedFacilityList.setValue(_id);
		}
		this.DateService.facilityData = this.facilityList[getFacilityIndex]
		this.DateService.facilityChanged.emit(this.facilityList.find(f => f._id === _id))
		//    this._router.navigate([], {
		// 	relativeTo: this._route,
		// 	queryParams: { unit: _e.value },
		// 	// queryParamsHandling: 'merge',
		//    });
	}

	setUnitName = (facilityData) => {
		const value = facilityData.units.filter(ele => ele._id === facilityData.activePlant);
		if (value.length > 0) this.unitValue.setValue(value[0].name) // set unit value
	}

	onRangeSelection(e) {
		this.currentTimeSelected = e;

		let range: any = {};

		if (e.id == 1) {
			// Today: from = today midnight (local), to = now
			range = { from: dayjs().startOf('day').toDate(), to: dayjs().toDate() };
		} else if (e.id == 2) {
			// Yesterday: from = yesterday midnight (local), to = yesterday 11:59:59 pm (local)
			const from = dayjs().subtract(1, 'day').startOf('day').toDate();
			const to = dayjs().subtract(1, 'day').endOf('day').toDate();
			range = { from, to };
		} else if (e.id == 3) {
			// Last 7 Days
			const from = dayjs().subtract(7, 'day').startOf('day').toDate();
			const to = dayjs().toDate();
			range = { from, to };
		} else if (e.id == 4) {
			// Last 30 Days
			const from = dayjs().subtract(30, 'day').startOf('day').toDate();
			const to = dayjs().toDate();
			range = { from, to };
		} else if (e.id == 5) {
			// Last 6 Months
			const from = dayjs().subtract(6, 'month').startOf('day').toDate();
			const to = dayjs().toDate();
			range = { from, to };
		} else if (e.id == 6) {
			// Last 12 Months
			const from = dayjs().subtract(12, 'month').startOf('day').toDate();
			const to = dayjs().toDate();
			range = { from, to };
		} else if (e.id == 7) {
			range = {};
		}

		this.DateService.dateRange = range;
		this.DateService.dateRangeSelectionChanged.emit(range);
	}

	renderOnDashboard() {
		this.DateService.facilityChanged.emit({ type: 9999 })
	}

	switchToAlertsV2Page(): void {
		// Navigate to the Alerts V2 page
		this._router.navigate(['/web/alert']);
	}
}
